import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';

const DEFAULT_ALLOWED_ROLES = ['System admin', 'User admin', 'User'];

const RoleGuard = ({ allowedRoles = DEFAULT_ALLOWED_ROLES, children }) => {
  const location = useLocation();
  const { userData, loading } = useSelector((state) => state.user);

  if (loading || !userData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
        <CircularProgress />
      </Box>
    );
  }

  const role = userData?.Role || '';
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
};

RoleGuard.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired
};

export default RoleGuard;
